import styled from 'styled-components';

export const DescriptionSubTitle = styled.h3`
  font-size: 14px;
  line-height: 21px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 8px;
  font-weight: 600;
`;

export const DescriptionText = styled(DescriptionSubTitle)`
  font-weight: 400;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const AuthorName = styled(DescriptionText)`
  margin-bottom: 0;
`;

export const AuthorImage = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-right: 12px;
  object-fit: cover;
`;

export const AuthorJobTitle = styled(DescriptionText)`
  font-size: 10px;
  margin-bottom: 0;
  line-height: 14px;
`;

export const Author = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`;
